import { render, staticRenderFns } from "./AttachmentPreviewDialog.vue?vue&type=template&id=6da35a72"
import script from "./AttachmentPreviewDialog.vue?vue&type=script&lang=js"
export * from "./AttachmentPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./AttachmentPreviewDialog.vue?vue&type=style&index=0&id=6da35a72&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports